import { coreAxios } from "@/declare/api/axios"
import { MaterialMark } from "@/declare/interface/project/material"
import { AxiosResponse } from "axios"


/**
 * 获取系统材料
 *
 * @return
 */
export function findMaterialList(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/materials`, {
        params: {
            ...params
        }
    })
}

/**
 * 获取系统材料分类
 * isTree为空或者false则只返回第一层分类，
 * isTree为true则返回组装好的分类、编码、材料三级树形结构
 *
 * @param isTree 是否返回树形结构
 * @return
 */
export function findMaterialCategoryList(isTree?: boolean, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/materials/categories`, {
        params: {
            ...params,
            isTree: isTree,
        }
    })
}

/**
 * 删除材料
 *
 * @param markUuid 材料uuid
 * @return
 */
export function deleteMaterial(markUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/materials/${markUuid}`, {
        params: {
            ...params,
        }
    })
}
/**
 * 新增
 *
 * @param material 材料信息
 * @return
 */
export function createMaterial(material: MaterialMark, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/materials`, material, {
        params: {
            ...params,
        }
    })
}

/**
 * 修改材料
 *
 * @param markUuid
 * @param material
 * @return
 */
export function updateMaterial(markUuid: string, material: MaterialMark, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/materials/${markUuid}`, material, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取材料详情
 *
 * @param markId 材料标号id
 * @return
 */
export function findMaterialMark(markUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/materials/${markUuid}`, {
        params: {
            ...params,
        }
    })
}


/**
 * 获取材料标准列表
 * @param params 
 * @returns 
 */
export function findMaterialCodeList(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/materials/codes`, {
        params: {
            ...params,
        }
    })
}